import type * as Types from '../../../gql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CurrentUserFeedbackWidgetQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CurrentUserFeedbackWidgetQuery = { __typename?: 'RootQueryType', currentUser?: { __typename?: 'User', id: string, firstName?: string | null, customerFeedbackReminderDate?: any | null } | null };


export const CurrentUserFeedbackWidgetDocument = gql`
    query CurrentUserFeedbackWidget {
  currentUser {
    id
    firstName
    customerFeedbackReminderDate
  }
}
    `;

/**
 * __useCurrentUserFeedbackWidgetQuery__
 *
 * To run a query within a React component, call `useCurrentUserFeedbackWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserFeedbackWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserFeedbackWidgetQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserFeedbackWidgetQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserFeedbackWidgetQuery, CurrentUserFeedbackWidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserFeedbackWidgetQuery, CurrentUserFeedbackWidgetQueryVariables>(CurrentUserFeedbackWidgetDocument, options);
      }
export function useCurrentUserFeedbackWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserFeedbackWidgetQuery, CurrentUserFeedbackWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserFeedbackWidgetQuery, CurrentUserFeedbackWidgetQueryVariables>(CurrentUserFeedbackWidgetDocument, options);
        }
// @ts-ignore
export function useCurrentUserFeedbackWidgetSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CurrentUserFeedbackWidgetQuery, CurrentUserFeedbackWidgetQueryVariables>): Apollo.UseSuspenseQueryResult<CurrentUserFeedbackWidgetQuery, CurrentUserFeedbackWidgetQueryVariables>;
export function useCurrentUserFeedbackWidgetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserFeedbackWidgetQuery, CurrentUserFeedbackWidgetQueryVariables>): Apollo.UseSuspenseQueryResult<CurrentUserFeedbackWidgetQuery | undefined, CurrentUserFeedbackWidgetQueryVariables>;
export function useCurrentUserFeedbackWidgetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserFeedbackWidgetQuery, CurrentUserFeedbackWidgetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserFeedbackWidgetQuery, CurrentUserFeedbackWidgetQueryVariables>(CurrentUserFeedbackWidgetDocument, options);
        }
export type CurrentUserFeedbackWidgetQueryHookResult = ReturnType<typeof useCurrentUserFeedbackWidgetQuery>;
export type CurrentUserFeedbackWidgetLazyQueryHookResult = ReturnType<typeof useCurrentUserFeedbackWidgetLazyQuery>;
export type CurrentUserFeedbackWidgetSuspenseQueryHookResult = ReturnType<typeof useCurrentUserFeedbackWidgetSuspenseQuery>;
export type CurrentUserFeedbackWidgetQueryResult = Apollo.QueryResult<CurrentUserFeedbackWidgetQuery, CurrentUserFeedbackWidgetQueryVariables>;